module.exports = "../../../../platform/assets/pageMainIcon/simple_yewushezhilei7.svg";